import React, { createContext, useContext, useEffect, useState } from 'react';
import { getOffline, setOffline, subscribeNetworkStatus } from '../utils/networkStatus';

const NetworkStatusContext = createContext({
  isOffline: false,
});

export const NetworkStatusProvider = ({ children }) => {
  const [isOffline, setIsOffline] = useState(() => {
    if (typeof navigator !== 'undefined' && navigator.onLine === false) {
      return true;
    }
    return getOffline();
  });

  useEffect(() => {
    const unsubscribe = subscribeNetworkStatus(setIsOffline);
    const handleOffline = () => setOffline(true);
    const handleOnline = () => setOffline(false);

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    return () => {
      unsubscribe();
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  return (
    <NetworkStatusContext.Provider value={{ isOffline }}>
      {children}
    </NetworkStatusContext.Provider>
  );
};

export const useNetworkStatus = () => useContext(NetworkStatusContext);


